<div>
  <!-- agenda-archives.component.html -->
  @for (task of tasks; track task) {
  <vw-card customClasses="bg-white rounded-xl flex gap-4 p-4 mb-3">
    <!-- Task icon -->
    <vw-icon-svg [iconUrl]="task.taskState === 'DONE' ? '/assets/svg/task.svg' : ''" additionalClasses="cursor-pointer"
      width="18"></vw-icon-svg>

    <div>
      <!-- Task name -->
      <p class="text-lg font-semibold leading-none pb-[2px] text-[#0C0D0D]">
        {{ task.name }}
      </p>
      <!-- Task description -->
      <p class="text-[#7A8581] text-sm">
        {{ task.shortDescription }}
      </p>

      <!-- Task metadata icons and labels -->
      <!--<div class="flex items-center gap-1 mt-2">
        @for (meta of task.metadata; track meta) {
          <div
            [class]="
              'text-xs font-semibold flex items-center gap-2 py-1 px-2 w-auto rounded-2xl' +
              ' ' + meta.color + ' border ' + meta.borderColor
            "
          >
            @if (meta.iconUrl) {
              <vw-icon-svg
              [iconUrl]="meta.iconUrl"
              additionalClasses="cursor-pointer"
              width="14"
            ></vw-icon-svg>
            {{ meta.label }}
            }
          </div>
        }
      </div>-->
    </div>
  </vw-card>
  }

  <!-- Articles  -->
  @if (!isLoading) {
  <div class="flex flex-col gap-4 mt-8 mb-28">
    <h2 class="text-primary-title text-2xl font-semibold">
      {{ "home.articles.title" | translate }}
    </h2>
    @for (article of articles; track article) {
    <vw-article [article]="article"></vw-article>
    }
  </div>
  }

</div>